import {
    REQUEST_CONSTANTS,
    RECEIVE_CONSTANTS,
    RELOAD_CONSTANTS,
    ERROR_CONSTANTS
} from '../types'
import {initialFetchState} from '../../constants/defaultValues'

export default (state = initialFetchState, action = {}) => {
    switch(action.type) {
        case REQUEST_CONSTANTS:
            return {
                ...state,
                isFetching: true,
                message: '',
                errors: {}
            }
        case RECEIVE_CONSTANTS:
            return {
                ...state,
                isFetching: false,
                data: action.payload,
                shouldReload: false,
                isFetched: true,
                errors: {},
                message: '',
            }
        case RELOAD_CONSTANTS:
            return {
                ...state,
                shouldReload: true
            }
        case ERROR_CONSTANTS:
            return {
                ...state,
                isFetching: false,
                errors: action.errors,
                message: action.errors.server || '',
            }
        default:
            return state
    }
}